var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBackToTop)?_c('el-button',{staticClass:"custom-back-to-top",attrs:{"round":""},on:{"click":_vm.scrollTo}},[_vm._v(_vm._s(_vm.$t('footer.back_to_top'))+" "),_c('i',{staticClass:"el-icon-top"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }